export const TENANT_ROUTES = {
	BOOKINGS: "/account/bookings",
	BOOKING_DETAIL: "/account/bookings/:referenceCode",
	BOOKING_CONTRACT: "/account/bookings/:referenceCode/contract",
	CAUTIONS: "/account/cautions",
	CAUTION_DETAIL: "/account/cautions/:id",
	PROFILE: "/account/profile",
} as const;
